/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_RatedInputs */

const en_directory_hubs_signals_rated = /** @type {(inputs: Directory_Hubs_Signals_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products with ratings`)
};

const zh_directory_hubs_signals_rated = /** @type {(inputs: Directory_Hubs_Signals_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有评分的产品`)
};

/**
* | output |
* | --- |
* | "Products with ratings" |
*
* @param {Directory_Hubs_Signals_RatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_rated = /** @type {((inputs?: Directory_Hubs_Signals_RatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_RatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_rated(inputs)
	return zh_directory_hubs_signals_rated(inputs)
});
export { directory_hubs_signals_rated as "directory.hubs.signals.rated" }